module.exports = __webpack_public_path__ + "static/media/ic-contact-chat.5974552c.svg";